import { ENDPOINT_WORKSPACE_SETTINGS } from '../config'
import type { SwitchToPersonalRequest, SwitchToPersonalResponse } from '../types'
import AuthAxios from '@/lib/api/axios/AuthAxios'

const switchToPersonal = async (
  workspaceSlug: string,
  request: SwitchToPersonalRequest,
): Promise<SwitchToPersonalResponse> => {
  const response = await AuthAxios.post<SwitchToPersonalResponse>(
    `${ENDPOINT_WORKSPACE_SETTINGS}/${workspaceSlug}/settings/switch-to-personal`,
    request,
  )
  return response.data
}

export default switchToPersonal
